import reports from './store/index';
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('reports$reports', reports);
};
